/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Hashtag",
  size: 20
}

const SvgHashtag = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M15.431 8l.23-1h-2.75l.92-4h-.93l-.921 4H9.29l.92-4h-.929l-.92 4H5.23L5 8h3.13l-.92 4H4.23L4 13h2.98l-.919 4h.93l.92-4h2.69l-.92 4h.93l.92-4h2.9l.23-1H11.76l.921-4h2.75zm-4.6 4h-2.69l.92-4h2.689l-.919 4z" />
  </Svg>
)

SvgHashtag.defaultProps = defaultProps
export default SvgHashtag
